module.exports = __webpack_public_path__ + "static/img/timg.91b3e01.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/timg.jpg
// module id = biZE
// module chunks = 1